module.exports = __webpack_public_path__ + "img/belgium-cardiovascular-diseases-female.8f7f449c.png";